// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Nunito', 'Nunito Fallback'"},"className":"__className_b4896b"};